import { ThunkAPI } from '../rootReducer';
import { ContentTypes, HttpMethods, SERVICES } from '../../services/api';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { IMetadataPayload } from '../metadata';

export const fetchAuth: AsyncThunk<IMetadataPayload, void, ThunkAPI> = createAsyncThunk(
  'auth/fetchAuth',
  async (_, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<IMetadataPayload, void>({
        endpoint: 'auth',
        microservice: SERVICES.AUTH_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: ContentTypes.ApplicationJson
      })(_, thunk);

      return response;
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);
